export default __webpack_public_path__ + "static/media/217.6755a002.jpg";